import { Alert } from "../../assets/images/Alert";
import { SecondaryDeleteButton } from "../../components/ui/button";
import { cn } from "../../utils/tailwind";
export const Error = ({ errorMessage, className }) => {
  return (
    <div
      className={cn("w-full flex items-center justify-start gap-2", className)}
    >
      <SecondaryDeleteButton className="w-full h-full flex items-center justify-start gap-0 sm:gap-2 px-2 text-xs sm:text-sm">
        <Alert className="w-8 h-8 text-negative text-start flex-shrink-0" />
        <span className="whitespace-pre-wrap break-words">{errorMessage}</span>
      </SecondaryDeleteButton>
    </div>
  );
};
